import { Component, EventEmitter, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { PromoCode } from '../models/promo-code';
import { MatDialog } from '@angular/material/dialog';
import { PromoCodeService } from '../services/promo-code.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { PromoCodeDiscountType } from 'src/app/shared/models/promo-code-discount-type.enum';
import { Sort } from '@angular/material/sort';
import { PromoCodeQueryFilter } from './promo-code-query-filter';
import { PromoCodeCreateModalComponent } from '../modals/promo-code/promo-code-create-modal/promo-code-create-modal.component';
import { PromoCodeEditModalComponent } from '../modals/promo-code/promo-code-edit-modal/promo-code-edit-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';

@Component({
    selector: 'promo-codes-list',
    templateUrl: './promo-codes-list.component.html',
    styleUrls: ['./promo-codes-list.component.scss'],
    standalone: false
})
export class PromoCodesListComponent extends BaseComponent implements OnInit {
  filter: PromoCodeQueryFilter = new PromoCodeQueryFilter();
  promoCodes: PromoCode[] = [];
  displayedColumns = ['code', 'discountType', 'discountAmount', 'startDate', 'endDate', 'usageLimit', 'currentUsageCount', 'isActive', 'actions'];
  DiscountType = PromoCodeDiscountType;
  public updateFilterEvent = new EventEmitter<any>();

  constructor(
    sessionService: SessionService,
    stringHelpers: StringHelpers,
    private promoCodeService: PromoCodeService,
    private dialog: MatDialog
  ) {
    super(sessionService, stringHelpers);
    this.displayedColumns = ['code', 'discountType', 'discountAmount', 'startDate', 'endDate', 'usageLimit', 'currentUsageCount', 'isActive', 'actions'];
  }

  ngOnInit() {
    this.getPromoCodes();
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getPromoCodes();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  createPromoCode(){
    const dialogRef = this.dialog.open(PromoCodeCreateModalComponent, {
      width: '40vw',
      height: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getPromoCodes();
      }
    });
  }

  editPromoCode(promoCode: PromoCode){
    const dialogRef = this.dialog.open(PromoCodeEditModalComponent, {
      width: '40vw',
      height: 'auto'
    });

    dialogRef.componentInstance.promoCode = promoCode;

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getPromoCodes();
      }
    });
  }

  deletePromoCode(promoCode: PromoCode){
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Promo Code';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Promo Code <strong>${promoCode.code}</strong>? This Promo Code will no longer be available for use and all bookings using this code may be affected.</h2>`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        this.promoCodeService.delete({id: promoCode.id, lastEditedBy: this.sessionService.getUserId()}).subscribe({
          next: () => {
            this.getPromoCodes();
          },
          error: (error) => {
            console.error(error);
            this.isLoading = false;
          },
          complete: () => this.isLoading = false
        });
      }
    });



  }

  toggleStatus(promoCode: PromoCode, event){
    this.isLoading = true;
    promoCode.isActive = event;
    promoCode.lastEditedBy = this.sessionService.getUserId();
    this.promoCodeService.update(promoCode.id, promoCode).subscribe({
      next: () => {
        this.getPromoCodes();
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }


  getPromoCodes() {
    this.isLoading = true;
    this.filter.organizationId = this.sessionService.getUser().organizationId;
    this.promoCodeService.getAllByOrganization(this.filter).subscribe({
      next: (result) => {
        this.promoCodes = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);  
      },
      error: (error) => {
        console.error(error);
        this.isLoading = false;
      },
      complete: () => this.isLoading = false
    });
  }
}
